/**
 * @description 绑定手机号相关逻辑
 */
import JsSHA from 'jssha';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { loginWechat } from '@/api/wechat.js';
import * as types from '@/types';
import * as userApi from '~/api/user';

export default {
  computed: {
    ...mapGetters('user', ['isLogin']),
  },
  methods: {
    ...mapMutations('user', {
      signIn: types.USER_SIGNIN,
      show: types.SHOW_LOGIN_FORM,
    }),
    ...mapActions('user', {
      logout: types.LOGOUT,
      loginLocal: types.LOGIN_LOCAL,
      getFollows: types.GET_FOLLOWS,
      getStockFollows: types.GET_STOCK_FOCUS,
    }),
    ...mapActions({
      updateVipMemberInfo: 'user/updateVipMemberInfo',
    }),
  },
  async mounted() {
    const query = this.$route.query;
    if (query.wxcode) {
      if (this.isLogin) {
        this.logout();
      } else {
        const timestamp = parseInt(new Date().getTime() / 1000);
        const signObj = new JsSHA('SHA-1', 'TEXT', {
          encoding: 'UTF8',
        });
        signObj.update(`${timestamp}${query.wxcode}wxfd29938cea1c1b3d`);
        const props = {
          timestamp,
          code: query.wxcode,
          sign: signObj.getHash('HEX'),
        };
        const loginData = await this.$axios(loginWechat(props));
        if (loginData.result && !loginData.result.agreeUserAgreement) {
          const res = await this.$axios(userApi.agreeAgreement());
          if (res.statusCode === 200) {
            // loginData.result.needBindPhone = true;
          }
        }
        if (loginData.result && loginData.result.needBindPhone) {
          // 有结果并且要求绑定手机
          const { nick, avatar } = loginData.result;
          this.show({
            bindWechatInfo: {
              nick,
              avatar,
            },
          });
        } else {
          // 否则路由重定向
          let url = `${this.$route.path}?`;
          for (const prop in query) {
            const lastStr = url.charAt(url.length - 1);
            if (prop !== 'wxcode') {
              url = `${url}${lastStr === '?' ? '' : '&'}${prop}=${query[prop]}`;
            }
          }
          const lastUrlStr = url.charAt(url.length - 1);
          if (lastUrlStr === '?') {
            url = url.substring(0, url.length - 1);
          }
          location.href = url;
        }
      }
    }
  },
};
